import useBillingPaymentProfileDetails from 'modules/queries/billing/payment/profile/useDetails';
import useBillingPaymentMake from 'modules/queries/billing/payment/useMake';
import usePaypalPaymentCreate from 'modules/queries/billing/paypal/payment/useCreate';
import useBrandName from 'utility/hooks/useBrandName';
import { useDialogMakePaymentContext } from '../dialogMakePaymentContext';
import ConfirmPaymentContent from './ConfirmPayment';

const ConfirmDefaultPayment = () => {
	const { formValues, onSubmitSuccess, onSubmitError } =
		useDialogMakePaymentContext();
	const { data: paymentProfileDetails } = useBillingPaymentProfileDetails({});
	const { mutate: makePayment, isLoading: isMakingPayment } =
		useBillingPaymentMake();
	const { mutate: paypalPaymentCreate, isLoading: isPaypalCreating } =
		usePaypalPaymentCreate();
	const brandName = useBrandName();

	const {
		payment_method: paymentMethod,
		masked_number: maskedCcNumber,
		cc_exp: ccExpiration,
		issuer,
	} = paymentProfileDetails || {};
	const { amount, cardCode } = formValues;

	const handleSubmit = () => {
		if (paymentMethod === 'paypal') {
			paypalPaymentCreate(
				{
					requested_amount: amount,
					lineItems: [{ amount, description: `My ${brandName} Payment` }],
					returnURL: `${window.location.origin}/account/billing`,
				},
				{
					onSuccess: onSubmitSuccess,
					onError: onSubmitError,
				},
			);
			return;
		}
		makePayment(
			{
				amount,
				card_code: cardCode,
			},
			{
				onSuccess: onSubmitSuccess,
				onError: onSubmitError,
			},
		);
	};

	return (
		<ConfirmPaymentContent
			amount={Number(amount)}
			ccExpiration={ccExpiration}
			isSubmitting={isMakingPayment || isPaypalCreating}
			issuer={issuer}
			maskedCcNumber={maskedCcNumber?.replaceAll('X', '')}
			onSubmit={handleSubmit}
			paymentMethod={paymentMethod}
		/>
	);
};

export default ConfirmDefaultPayment;
